import { FormicaSelectBoxItem } from '../components/custom/FormicaSearchSelectBox';

export namespace SarXmlTags {
  export const GERCEKKISI_TAGS = [
    'islemlebaglantisi',
    'islemlebaglantisiaciklama',
    'adi',
    'soyadi',
    'tckn',
    'vkn',
    'ykn',
    'dogumtarihi',
    'dogumyeri',
    'anaadi',
    'babaadi',
    'uyrugu',
    'cinsiyeti',
    'meslek',
    'ekbilgi',
    'kimlikbilgilerisahte',
    'magdur',
    'kimliktespitturu',
  ] as const;

  export const KIMLIKBELGESI_TAGS = ['belgeturu', 'belgenumarasi', 'gecerliliktarihi'] as const;

  export const ADDRESS_TAGS = ['adressatir', 'postakodu', 'ilkodu', 'ilcekodu', 'ulkekodu'] as const;

  export const DIGERKISI_TAGS = [
    'islemlebaglantisi',
    'islemlebaglantisiaciklama',
    'kurulusnevi',
    'unvan',
    'isletmeadi',
    'vkn',
    'sicilno',
    'faaliyetkonusu',
    'ulkekodu',
    'ilkodu',
    'ilcekodu',
    'kurulustarihi',
    'websitesi',
    'ekbilgi',
    'kimlikbilgilerisahte',
    'magdur',
  ] as const;

  export const HESAP_TAGS = [
    'sahisfirmasihesabi',
    'hesapturu',
    'hesapno',
    'iban',
    'acilistarihi',
    'kapanistarihi',
    'sonislemtarihi',
    'bakiyetp',
    'bakiye',
    'parabirimi',
    'kisitlamaturu',
    'kisitlamadigeraciklama',
  ] as const;

  export const HESAP_OWNER_TAGS = ['magdur', 'adsoyadunvan', 'tckn', 'vkn', 'ykn', 'pasaport'] as const;

  export const SUPHELIISLEM_TAGS = [
    'islemcesidi',
    'islemtarihi1',
    'islemtarihi2',
    'islemdurumu',
    'hesababagli',
    'tutartp',
    'tutar',
    'parabirimi',
    'islemturu',
    'islemkanali',
    'ipv4',
    'port',
    'islemaciklamasi',
    'ulkekodu',
    'ilkodu',
    'ilcekodu',
    'islemingerceklestirildigiyer',
    'islemintetiklendigiyer',
    'islemearaciliketmedurumu',
    'islemearacilikedenkurum',
  ] as const;
}

export const getContactInfoTypeOptions = () => [
  { label: 'İş Telefonu', value: 'is' },
  { label: 'Ev Telefonu', value: 'ev' },
  { label: 'Cep Telefonu', value: 'cep' },
  { label: 'Diğer Telefon', value: 'diger' },
  { label: 'Faks', value: 'faks' },
  { label: 'E-posta', value: 'eposta' },
];


export const getBildirimKategorisiOptions = (): FormicaSelectBoxItem[] => [
  { label: 'BK-01 Suç Gelirlerinin Aklanması', value: 'BK-01' },
  { label: 'BK-02 Terörizmin Finansmanı ', value: 'BK-02' },
  { label: 'BK-03 Kitle İmha Silahlarının Yayılmasının Finansmanı', value: 'BK-03' },
];

export const getAciliyetOptions = (): FormicaSelectBoxItem[] => [
  { label: 'A-01 Normal', value: 'A-01' },
  { label: 'A-02 İvedi', value: 'A-02' },
  { label: 'A-03 Çok İvedi', value: 'A-03' },
  { label: 'A-04 İşlemin Ertelenmesi Talepli', value: 'A-04' },
];

export const getTerorOrgutuOptions = (): FormicaSelectBoxItem[] => [
  { label: 'TO-01 Bölücü Terör Örgütleri', value: 'TO-01' },
  { label: 'TO-02 Dini İstismar Eden Terör Örgütleri ', value: 'TO-02' },
  { label: 'TO-03 Aşırı Sol Terör Örgütleri', value: 'TO-03' },
];
